import { EVENT_LABELS } from '@/common/utils/eventTracker'

export const LOCAL_STORAGE_KEY = 'editor_tutorial'

export const LOCAL_STORAGE_EDITOR_TOUR_GUIDE = 'editor_tour_guide'

export const LOCAL_STORAGE_FAVORITE_PRODUCTS = 'cache_favorite_products_carousel'

export enum EDITOR_TUTORIAL_TYPES {
  PRODUCT_TUTORIAL = 'product_tutorial',
  MAIN_TUTORIAL_MODAL = 'old_tutorial_modal',
  MAIN_TOUR_GUIDE = 'main_tour_guide',
  SINGLE_COLOR_TOOLTIP = 'single_color_tooltip'
}

export enum TOUR_STEP_IDS {
  ADD_DESIGN_FILE_TEXT = 'e-tour-start-design',
  ADD_IMAGE_TEXT_BUTTONS = 'e-tour-add-image-text',
  SINGLE_COLOR_SELECTION = 'e-tour-single-color-select',
  SINGLE_COLOR_SELECTION_MOBILE = 'e-tour-single-color-select_mobile',
  NAMING_EDITOR = 'e-tour-naming-editor',
  EDIT_TEXT_CONTROLS = 'e-tour-edit-text-control',
  EDIT_TEXT_CONTROLS_MOBILE = 'e-tour-edit-text-control_mobile',
  PREVIEW_ACTIONS = 'e-tour-preview-action',
  PREVIEW_ACTIONS_MOBILE = 'e-tour-preview-action_mobile',
  SHARE_ACTION_MOBILE = 'e-tour-share-button_mobile'
}

export const TOUR_GUIDE_STEPS = [
  {
    desk_id: TOUR_STEP_IDS.ADD_DESIGN_FILE_TEXT,
    mobi_id: TOUR_STEP_IDS.ADD_DESIGN_FILE_TEXT,
    index: 0,
    title: 'デザインや文字を追加する',
    body: 'まず初めに、ここからお手元のデザインデータや印刷したい文字を追加します。',
    placement: 'top-start',
    backdrop: false
  },
  {
    desk_id: TOUR_STEP_IDS.ADD_IMAGE_TEXT_BUTTONS,
    mobi_id: TOUR_STEP_IDS.ADD_IMAGE_TEXT_BUTTONS,
    index: 0,
    title: 'デザインや文字を追加する',
    body: 'デザインデータや文字は、こちらから追加することもできます。',
    placement: 'bottom-start'
  },
  {
    mobi_id: TOUR_STEP_IDS.SHARE_ACTION_MOBILE,
    index: 0,
    title: '',
    body: 'パソコンでデザイン編集がしたい時は、共有するボタンを使うと便利です。',
    mobi_placement: 'top-start'
  },
  {
    desk_id: TOUR_STEP_IDS.SINGLE_COLOR_SELECTION,
    mobi_id: TOUR_STEP_IDS.SINGLE_COLOR_SELECTION_MOBILE,
    index: 0,
    title: '印刷色を変更する',
    body: 'こちらから印刷する色の変更ができます。',
    placement: 'bottom-end',
    mobi_placement: 'bottom-start'
  },
  {
    desk_id: TOUR_STEP_IDS.NAMING_EDITOR,
    mobi_id: TOUR_STEP_IDS.NAMING_EDITOR,
    index: 0,
    title: '編集する印刷箇所を切り替える',
    body: 'こちらから編集したい印刷箇所に切り替えることができます。',
    placement: 'right-start',
    mobi_placement: 'top-start'
  },
  {
    desk_id: TOUR_STEP_IDS.EDIT_TEXT_CONTROLS,
    mobi_id: TOUR_STEP_IDS.EDIT_TEXT_CONTROLS_MOBILE,
    index: 0,
    title: '入力した文字を変更する',
    body: 'デザインする文字の内容や、書体、文字サイズの変更ができます。',
    placement: 'left-start',
    mobi_placement: 'top'
  },
  {
    desk_id:  TOUR_STEP_IDS.PREVIEW_ACTIONS,
    mobi_id: TOUR_STEP_IDS.PREVIEW_ACTIONS_MOBILE,
    index: 0,
    title: 'デザインの確認・保存する',
    body: '',
    placement: 'left-start',
    mobi_placement: 'top-end'
  }
]

export const tourEventLabel = (tourStepId: string) => {
  let eventLabel
  switch (tourStepId) {
    case TOUR_STEP_IDS.ADD_DESIGN_FILE_TEXT:
      eventLabel = EVENT_LABELS.LOGO_TEXT_ADD_CENTER
      break
    case TOUR_STEP_IDS.ADD_IMAGE_TEXT_BUTTONS:
      eventLabel = EVENT_LABELS.LOGO_TEXT_ADD_LEFT_TOP
      break
    case TOUR_STEP_IDS.SINGLE_COLOR_SELECTION:
      eventLabel = EVENT_LABELS.COLOR_PATTERN_CHANGE
      break
    case TOUR_STEP_IDS.SINGLE_COLOR_SELECTION_MOBILE:
      eventLabel = EVENT_LABELS.COLOR_PATTERN_CHANGE
      break
    case TOUR_STEP_IDS.NAMING_EDITOR:
      eventLabel = EVENT_LABELS.EDIT_PATTERN_CHANGE
      break
    case TOUR_STEP_IDS.EDIT_TEXT_CONTROLS:
      eventLabel = EVENT_LABELS.TEXT_CHANGE
      break
    case TOUR_STEP_IDS.EDIT_TEXT_CONTROLS_MOBILE:
      eventLabel = EVENT_LABELS.TEXT_CHANGE
      break
    case TOUR_STEP_IDS.PREVIEW_ACTIONS:
      eventLabel = EVENT_LABELS.DESIGN_PREVIEW_OPEN
      break
    case TOUR_STEP_IDS.PREVIEW_ACTIONS_MOBILE:
      eventLabel = EVENT_LABELS.DESIGN_PREVIEW_OPEN
      break
    case TOUR_STEP_IDS.SHARE_ACTION_MOBILE:
      eventLabel = EVENT_LABELS.DESIGN_PC_SHARE
      break
  }
  return eventLabel
}
